export default __webpack_public_path__ + "static/media/loading.41fbd2d3.gif";